// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { CirclePlus as RawCirclePlus } from "lucide-react";
export const CirclePlus = /* @__PURE__ */ createIcon(RawCirclePlus, "CirclePlus", 2);
